
import { useState, useEffect } from 'react';
import { GroupTagPicker } from './GroupTagPicker';
import { useQuery, gql } from '@apollo/client';

const GET_ORGANISATION_COURSE_ID_FORMULA = gql`
query Organisation {
    me {
        organisation {
            courseIdentifierFormula
        }
    }
}`;

interface IProps {
    setSku: any,
    setTagIds: any,
    showErrors: boolean,
}

const CourseSKUPicker = ({
    setSku,
    setTagIds,
    showErrors,
}: IProps) => {
    // TODO: get this from the organisation settings

    const { loading, data } = useQuery(GET_ORGANISATION_COURSE_ID_FORMULA);

    const [skuParts, setSkuParts] = useState(
        [].map((groupId: any) => {
            return {
                groupId,
                tagId: 0,
                value: 'XX'
            }
        })
    );

    useEffect(() => {
        if (data) {
            const formula = data.me.organisation.courseIdentifierFormula;
            const groupIds = formula.split(',').map((part: string) => parseInt(part, 10));
            setSkuParts(
                groupIds.map((groupId: any) => {
                    return {
                        groupId,
                        tagId: 0,
                        value: 'XX'
                    }
                })
            );
        }
    }, [data]);

    if (loading) return <p>Loading...</p>;

    // map groupIds to GroupTagPicker components
    return (
        <>
            {skuParts.map(({groupId}) => (
                <GroupTagPicker
                    key={groupId}
                    showErrors={showErrors}
                    groupId={groupId}
                    setValue={(s:string, groupId: number, tagId: number) => {
                        const newSkuParts = skuParts.map((skuPart) => {
                            if (skuPart.groupId === groupId) {
                                return {
                                    ...skuPart,
                                    tagId,
                                    value: s
                                }
                            }
                            return skuPart;
                        });
                        setSkuParts(newSkuParts);
                        setTagIds(newSkuParts.filter((skuPart) => skuPart.tagId).map((skuPart) => skuPart.tagId));
                        setSku(newSkuParts.map((skuPart) => skuPart.value).join('-'));
                    }}
                />
            ))}
            <br/>
        </>
    );
}

export { CourseSKUPicker }
